import { Component, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem, ProductChannel } from '@core/models';
import { CartsPresenter } from './cart-items.presenter';
import { IAbstractView } from '@core/interfaces';
import { ICardItemsComponent, ICardItemsPresenter, ICartItemTotal } from './interfaces';
import { IntegerToFloatPipe } from '@core/pipes/integer-to-float.pipe';
import { Observable } from 'rxjs';
import { IconComponent } from '@shared/components';
import { QuantityStepperComponent } from '../quantity-stepper/quantity-stepper.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CartItemAvailabilityStatusEnum } from '@core/enums';

@Component({
	selector: 'app-cart-items',
	templateUrl: './cart-items.component.html',
	styleUrls: ['./cart-items.component.scss'],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, IntegerToFloatPipe, IconComponent, QuantityStepperComponent],
	providers: [CartsPresenter],
	standalone: true,
})
export class CartsComponent extends IAbstractView<ICardItemsPresenter> implements ICardItemsComponent {
	readonly CartItemAvailabilityStatusEnum = CartItemAvailabilityStatusEnum;
	hoveredIndex = this.presenter.hoveredIndex;
	detailsOpenIndex = this.presenter.detailsOpenIndex;
	image = this.presenter.image;
	no_image = this.presenter.no_image;
	translations = this.presenter.translations;
	decimalPrecision = this.presenter.decimalPrecision;
	cartItemsWithTotals = this.presenter.cartItemsWithTotals;

	@Input() cartItems$ = this.presenter.cartItems$;
	@Input() showSummary = this.presenter.showSummary;
	@Input() currentStep = this.presenter.currentStep;
	@Input() max: number | null = null;

	@Output() itemDeleted = this.presenter.itemDeleted;
	@Output() itemIncreased = this.presenter.itemIncreased;
	@Output() itemDecreased = this.presenter.itemDecreased;
	@Output() itemChanged = this.presenter.itemChanged;

	constructor(presenter: CartsPresenter) {
		super(presenter);
	}

	editItem(item: MenuItem): void {
		this.presenter.editItem(item);
	}

	deleteItem(item: MenuItem, index: number): void {
		this.presenter.deleteItem(item, index);
	}

	increaseAmount(item: MenuItem): void {
		this.presenter.increaseAmount(item);
	}

	decreaseAmount(item: MenuItem): void {
		this.presenter.decreaseAmount(item);
	}

	onImgError(event: Event): void {
		this.presenter.onImgError(event);
	}

	trackById(_: number, item: MenuItem): string {
		return this.presenter?.trackById(_, item);
	}

	trackByItemId(_: number, itemWithTotal: ICartItemTotal): string {
		return this.presenter?.trackByItemId(_, itemWithTotal);
	}

	isMinQty(item: MenuItem): boolean {
		return this.presenter.isMinQty(item);
	}

	attributeProduct<T extends keyof MenuItem>(key: T, item: MenuItem): Observable<MenuItem[T] | null> {
		return this.presenter.attributeProduct(key, item);
	}

	productChannel<T extends keyof ProductChannel>(key: T, item: MenuItem): Observable<ProductChannel[T] | number | bigint | null> {
		return this.presenter.productChannel(key, item);
	}

	getPrice(item: MenuItem): Observable<bigint | number | null> {
		return this.presenter.getPrice(item);
	}

	changeAmount(item: MenuItem, value: number): void {
		this.presenter.changeAmount(item, value);
	}
}
